import React, { useEffect, useState } from "react";
import {
	getDataFromJwt,
	isAdmin,
	isUser,
	isVolunteer,
	replaceIdInUrl,
	toastMaker,
} from "../utils/utility";
import {
	LIST_MY_PROFILES,
	UPDATE_ACCOUNT_VOLUNTEER,
	VIEW_ACCOUNT_ADMIN,
	PAYMENT_VIA_PROFILE,
} from "../API_LIST";
import matrimonyInstance from "../utils/axios";
import { useLocation, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Popup from "../component/section/popup";
import { useSelector } from "react-redux";
import StripeSubscription from "../component/payment/StripeSubscription";
import EditProfile from "./editProfile";
import ProfileCard from "../component/section/profileCard";
import ProfilesAccordion from "../component/section/profilesAccordion";

export default function ViewAccount() {
	const userRoleId = getDataFromJwt("role");
	const [userDetails, setUserDetails] = useState();
	const [modalIsOpen, setIsOpen] = useState(false);
	const [isPaymentVisible, setPaymentVisible] = useState(false);

	const { id } = useParams();
	const url = useLocation();
	let selectedProfile = useSelector((state) => state.auth.currentProfile);
	const isEdit = false; //url?.pathname?.contains("edit");
	useEffect(() => {
		let url = replaceIdInUrl(VIEW_ACCOUNT_ADMIN, id);
		matrimonyInstance.get(url).then((response) => {
			console.log("data", response.data.rows);
			let objectIs = response.data;
			setUserDetails(objectIs);
		});
	}, []);

	function updateAccount(value) {
		let data = {
			verification_status: value,
		};
		let url = replaceIdInUrl(UPDATE_ACCOUNT_VOLUNTEER, id);
		matrimonyInstance.put(url, data).then((response) => {
			if (response.data) {
				setUserDetails(response.data.updatedAccount);
				toastMaker(response.data.message);
			}
		});
	}

	const togglePaymentVisibility = () => {
		setIsOpen(true);
		setPaymentVisible(true);
	};

	const EnableorDisableAccount = (_className) => {
		return (
			<div className={_className}>
				{canApprove ? (
					userDetails?.account_verification_status == "approved" ? (
						<div className="d-flex gap-3">
							<button
								className=" btn-decline"
								onClick={() => updateAccount("declined")}
							>
								Disable Account
							</button>
						</div>
					) : (
						<div className="d-flex gap-3">
							<button
								className="btn-approve"
								onClick={() => updateAccount("approved")}
							>
								Enable Account
							</button>
						</div>
					)
				) : null}
			</div>
		);
	};

	const AccountData = [
		{ name: "First Name", key: "first_name" },
		{ name: "Last Name", key: "last_name" },
		{ name: "Gender", key: "gender" },
		{ name: "Email", key: "email" },
		{ name: "Phone Number", key: "phone_number" },
		{ name: "Address Line 1", key: "address_1" },
		{ name: "Address Line 2", key: "address_2" },
		{ name: "Gotram", key: "gotram" },
	];

	function closeModal() {
		setIsOpen(false);
		setPaymentVisible(false);
	}

	let profileStatusImage;
	if (userDetails?.account_verification_status === "approved") {
		profileStatusImage = "status-approved";
	} else if (userDetails?.account_verification_status === "declined") {
		profileStatusImage = "status-rejected";
	} else {
		profileStatusImage = "status-pending";
	}

	let canApprove = isAdmin() || isVolunteer();

	return (
		<React.Fragment>
			<div className="dashboard-content">
				<div className="d-flex justify-content-center">
					{userDetails && (
						<div className="view-profile-card mb-20 mt-50">
							<div className="d-flex justify-content-between align-items-center">
								<div className="d-flex gap-3 align-items-center">
									<h5 className="fw-700">
										{userDetails?.first_name} {userDetails?.last_name} Details
									</h5>
									<div className="d-flex">
										<img
											src={`../../assets/images/bat-img/${profileStatusImage}.svg`}
											title="Account verification status"
										/>
									</div>
								</div>
								{EnableorDisableAccount("is-desktop-approve-decline")}
								{isUser() && id !== selectedProfile.profile_id ? (
									<img
										src="../../assets/images/bat-img/profile-edit.svg"
										className="profile-edit-icon cursor-pointer"
										width={20}
										onClick={() => {
											setIsOpen(true);
										}}
									/>
								) : null}
							</div>
							{EnableorDisableAccount("is-responsive-approve-decline")}
							{AccountData?.map((item, index) => (
								<p key={index}>
									<span className="key mr-10">{item?.name}:</span>
									<span>{userDetails[item?.key]}</span>
								</p>
							))}
							{userDetails?.profiles && userDetails?.profiles.length ? (
								<div className="mt-30">
									<h5>List of Matrimony Profiles</h5>
									<br />
									<ProfilesAccordion profilesData={userDetails.profiles} />
								</div>
							) : null}
						</div>
					)}
				</div>
				{userDetails &&
					userDetails.profile_id &&
					!canApprove &&
					userDetails.payment_status === "unpaid" &&
					userDetails.profile_verification_status === "approved" && (
						<div className="d-flex justify-content-center">
							<div className="view-profile-card">
								<button
									className="button payment-btn"
									onClick={togglePaymentVisibility}
								>
									{isPaymentVisible ? "Hide Payment Details" : "Make Payment"}
								</button>
							</div>
						</div>
					)}

				{/* {isPaymentVisible && (
          <div className="d-flex justify-content-center">
            <StripeSubscription
              profileId={userDetails.profile_id}
              accountEmail={userDetails.account_email}
            />
          </div>
        )} */}
			</div>
			<Popup
				modalIsOpen={modalIsOpen}
				closeModal={closeModal}
				html={
					!isPaymentVisible ? (
						<EditProfile
							isEdit={true}
							userDetails={userDetails}
							closeModal={closeModal}
							setUserDetails={setUserDetails}
						/>
					) : (
						<StripeSubscription
							profileId={userDetails?.profile_id}
							accountEmail={userDetails?.account_email}
						/>
					)
				}
			/>
		</React.Fragment>
	);
}
